interface Props {
    children?: React.ReactNode
}
export function WorksheetLayout(props:Props) {
    return <div className="WorksheetLayout gap-6 ">{props.children}</div>
}
export function WorksheetRow(props:Props) {
    return <div className="WorksheetRow flex-row flex mb-5 w-full gap-6">{props.children}</div>
}
export function WorksheetColumn(props:Props) {
    return <div className="WorksheetColumn flex-col flex mb-5 mr-10 flex-1">{props.children}</div>
}